export function findScopeVariableMatches(searchString, scopes = ['scope']) {
    const p = RegExp(`{{(?:${scopes.join('|')}):([^}]+)}}`, 'gm');
    const matchedString = [];
    if (searchString) {
        let matches;
        while ((matches = p.exec(searchString)) !== null) {
            if (matches && matches[1]) {
                matchedString.push(matches[1]);
            }
        }
    }
    return matchedString;
}
